/** Electron 无边框窗口顶栏高度，需计入窗口总高度 */
export const ELECTRON_TITLE_BAR_HEIGHT = 25;

/** 认证页品牌区宽度 */
export const AUTH_BRAND_WIDTH = 380;

/** 认证页表单区宽度 */
export const AUTH_FORM_WIDTH = 440;

/** 认证窗口总宽度 = 品牌区 + 表单区 */
export const AUTH_WINDOW_WIDTH = AUTH_BRAND_WIDTH + AUTH_FORM_WIDTH;

export const MAIN_WINDOW = {
	width: 970,
	height: 660,
	minWidth: 970,
	minHeight: 600
};

/** 页面内容区高度（不含顶栏） */
export const AUTH_CONTENT_HEIGHT = {
	login: 560,
	register: 620,
	resetPwd: 580,
	demoLogin: 560
};

export function getAuthWindowSize(page = 'login') {
	const contentHeight = AUTH_CONTENT_HEIGHT[page] || AUTH_CONTENT_HEIGHT.login;
	return {
		width: AUTH_WINDOW_WIDTH,
		height: contentHeight + ELECTRON_TITLE_BAR_HEIGHT
	};
}
